/**
 * PlaceCoreStickyActions — Fixed bottom bar on mobile.
 * Primary: Vägbeskrivning. Secondary icons: save + share.
 */
import { Button } from "@/components/ui/button";
import { Navigation, Share2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { FavoriteButton } from "@/components/favorites/FavoriteButton";

interface Props {
  googleMapsUrl: string;
  onShare: () => void;
  placeId: string;
  placeSlug?: string;
  placeName?: string;
  placeImagePath?: string;
}

export function PlaceCoreStickyActions({ googleMapsUrl, onShare, placeId, placeSlug, placeName, placeImagePath }: Props) {
  const isMobile = useIsMobile();
  if (!isMobile) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex gap-3 px-4 py-3">
        <Button asChild className="flex-1 h-11 gap-2 rounded-full" size="lg">
          <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
            <Navigation className="h-4 w-4" />
            Vägbeskrivning
          </a>
        </Button>
        <FavoriteButton
          kind="place"
          entityId={placeId}
          slug={placeSlug}
          title={placeName}
          imagePath={placeImagePath}
          size="md"
          location="detail"
        />
        <Button
          variant="outline"
          size="lg"
          className="h-11 w-11 rounded-full shrink-0 p-0"
          onClick={onShare}
          aria-label="Dela"
        >
          <Share2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
